<template>
	<div>
		<div class="d-flex flex-column align-center width-full">
			<h2 v-if="!hideHeader" class="text-title-s d-flex align-self-start mb-2">
				{{ $t('Common_Profile_Title_Profile_Photo') }}
			</h2>
			<Avatar style="width: 80px; height: 80px" :src="imageUrl" />
			<InputFile
				class="py-2"
				:button-text="$t('Profile_Owner_Edit_Profile_picture')"
				@change="uploadImage"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { ref } from 'vue'
	import { ProfileActions } from '~/actions/profile/action'

	interface Props {
		hideHeader: boolean
		picture?: string
	}

	const props = defineProps<Props>()
	const emit = defineEmits(['change'])

	const imageUrl = ref<string | undefined>(props.picture)

	const uploadImage = async (file: File): Promise<void> => {
		if (!file) return
		const media = await ProfileActions.uploadAvatar(file)
		imageUrl.value = URL.createObjectURL(file)
		emit('change', { id: media?.id, url: imageUrl.value })
	}
</script>
